/**
 * Keeps sign-in keys and passwords out of LogRocket recordings (HERA-9169).
 * Runs in the browser, so removed values are never sent to LogRocket.
 */

// Cognito sign-in calls carry the 30-day refresh token and temporary AWS keys
// in their bodies and responses.
const COGNITO_URL = /cognito-(idp|identity)\./i

const AUTH_HEADER = /^(authorization|x-amz-security-token)$/i

// AdminQueries /changePassword posts the old and new passwords in plain text.
const CHANGE_PASSWORD_URL = /\/changePassword(\?|$)/

/**
 * LogRocket network.requestSanitizer. Returning null drops the call and its
 * response from the recording.
 * @param {{url: string, headers?: Object, body?: string}} request
 * @returns {Object|null}
 */
export function sanitizeLogRocketRequest(request) {
  if (COGNITO_URL.test(request.url)) return null

  for (const name of Object.keys(request.headers || {})) {
    if (AUTH_HEADER.test(name)) request.headers[name] = null
  }

  if (CHANGE_PASSWORD_URL.test(request.url)) request.body = null

  return request
}
